module.exports = __webpack_public_path__ + "img/share-white.ae796ea1.svg";